import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./NotifyUserFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

import NotifyUserFormStepOne from "./NotifyUserFormSteps/NotifyUserFormStepOne";

const NotifyUserForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  const normalizeRepresentativeLabel = (el) => {
    const fullName = [el?.name, el?.lastname].filter(Boolean).join(" ");

    return [fullName, el?.email, el?.phoneNumber].filter(Boolean).join(" · ");
  };
  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={false}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="NotifyUserForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <NotifyUserFormStepOne {...formProps} {...props} />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default NotifyUserForm;
